export const generateBatchNumber = () => {
  const prefix = "BN-";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let randomSegment = "";

  for (let i = 0; i < 6; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    randomSegment += characters[randomIndex];
  }

  return `${prefix}${randomSegment.toUpperCase()}`;
};
